import { Component } from '@angular/core';
import { AuthenticationService } from '../../providers/authentication.service';
import { Router } from '@angular/router';
import { DatabaseService } from '../../providers/database.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent {

  public update: FormGroup;
  public devisform: FormGroup;
  public user: any;
  public devis: any;
  public error: any;
  public infos: any = '';
  public state: any;
  public commande: any = '';
  public faq: any;
  public success: boolean;
  public email: any;
  public mydevis: any;
  public mycomment: any;
  public updateSucess = false;
  public search: FormGroup;
  public searching = false;
  public recherche: any;
  constructor(public auth: AuthenticationService,
              public db: DatabaseService,
              private router: Router,
              private formBuilder: FormBuilder) {

    this.isAdmin();
    this.initForms();
    this.getdevisstate();
    this.faq = this.db.getAllSav();

    this.search = this.formBuilder.group({
      text: ['', Validators.required]
    });
  }

  logout() {
    this.auth.logout().then(() => {
      this.auth.definedAuthData(false).then( () => {
        this.router.navigate(['/home']);
      });
    });
  }

  isAdmin() {
    this.auth.islogin().then(data => {
      this.user = data;
      this.db.getUser(data).valueChanges().forEach(user => {
        this.db.getmydevis(this.user['uid']).valueChanges().forEach( devis => {
          this.mydevis = devis;
        });
        this.db.getmycomment(this.user['uid']).valueChanges().forEach( comment => {
          this.mycomment = comment;
        });
        this.updateForm(user);
        this.loadDevis(user);
        this.loadCommande(user);
      });
      if (data['uid'] === this.auth.admin) {
        this.router.navigate(['/admin']);
      }
    });
  }

  loadDevis(data) {
    console.log(data);
    this.infos = data;
  }

  loadCommande(data) {
    this.commande = data;
  }

  initForms() {
    this.update = this.formBuilder.group({
      email: [''],
      firstname: [''],
      lastname: [''],
      company: [''],
      tel: [''],
      poste: [''],
      siret: ['']
    });
    this.devisform = this.formBuilder.group({
      couvert: ['', Validators],
      phone: ['', Validators],
      message: ['', Validators],
      type: ['', Validators]
    });
  }

  updateInfo() {
    this.updateSucess = false;
    this.error = false;
    console.log(this.update.value);
    this.verifyForm(this.update.value).then( () => {
      this.db.updateUser(this.update.value, this.user['uid']);
      this.updateSucess = true;
    });
  }

  updateForm(user) {
    this.update.patchValue({
      email: user['email'],
      firstname: user['prenom'],
      lastname: user['nom'],
      company: user['entreprise'],
      poste: user['poste'],
      tel: user['tel'],
      siret: user['siret']
    });

    this.email = user['email'];
  }

  gestionError(log: any) {
    switch (log.code) {
      case 'auth/invalid-email':
        this.error = 'Adresse email invalide';
        break;
      case 'auth/wrong-password':
        this.error = 'Mot de passe incorrect';
        break;
      case 'auth/user-not-found':
        this.error = 'L\'adresse email indiqué n\'est pas enregistrer sur le site';
        break;
      case 'auth/weak-password':
        this.error = 'Votre mot de passe doit contenir au moins 6 charactères';
        break;
      case 'auth/email-already-in-use':
        this.error = 'Cette adresse email est déjà utilisée';
        break;
      case 'inscription/invalid-email':
        this.error = log.message;
        break;
      case 'inscription/invalid-password':
        this.error = log.message;
        break;
      case 'inscription/invalid-firstname':
        this.error = log.message;
        break;
      case 'inscription/invalid-lastname':
        this.error = log.message;
        break;
      case 'inscription/invalid-company':
        this.error = log.message;
        break;
      case 'inscription/invalid-poste':
        this.error = log.message;
        break;
      case 'inscription/invalid-tel':
        this.error = log.message;
        break;
      case 'inscription/invalid-siret':
        this.error = log.message;
        break;
      default:
        this.error = 'Une erreur c\'est produite';
        break;
    }
  }

  verifyForm(form: FormGroup) {
    return new Promise((resolve, reject) => {
      if (form['email'] === '') {
        const log = {
          code: 'inscription/invalid-email',
          message: 'Vueillez indiquer votre email'
        };
        this.gestionError(log);
        reject(log.code);
      } else if (form['password'] === '') {
        const log = {
          code: 'inscription/invalid-password',
          message: 'Vueillez indiquer votre mot de passe'
        };
        this.gestionError(log);
        reject(log.code);
      } else if (form['firstname'] === '') {
        const log = {
          code: 'inscription/invalid-firstname',
          message: 'Vueillez indiquer votre prénom'
        };
        this.gestionError(log);
        reject(log.code);
      } else if (form['lastname'] === '') {
        const log = {
          code: 'inscription/invalid-lastname',
          message: 'Vueillez indiquer votre nom'
        };
        this.gestionError(log);
        reject(log.code);
      } else if (form['company'] === '') {
        const log = {
          code: 'inscription/invalid-company',
          message: 'Vueillez indiquer votre entreprise'
        };
        this.gestionError(log);
        reject(log.code);
      } else if (form['poste'] === '') {
        const log = {
          code: 'inscription/invalid-poste',
          message: 'Veuillez indiquer votre poste dans l\'entreprise'
        };
        this.gestionError(log);
        reject(log.code);
      } else if (form['tel'] === '') {
        const log = {
          code: 'inscription/invalid-tel',
          message: 'Veuillez indiquer numéro de téléphone'
        };
        this.gestionError(log);
        reject(log.code);
      } else if (form['siret'] === '') {
        const log = {
          code: 'inscription/invalid-siret',
          message: 'Vueillez indiquer votre siret'
        };
        this.gestionError(log);
        reject(log.code);
      } else {
        resolve();
      }
    });
  }

  needHelp() {
    this.db.adddevis(this.infos, this.devisform.value).then(() => {
      localStorage.setItem('devis', 'encours');
      this.getdevisstate();
    });
  }

  getdevisstate() {
    this.state = localStorage.getItem('devis');
  }

  reset() {
    this.success = false;
    this.auth.resetPassword(this.email).then( data => {
      this.success = true;
    }).catch( rejected => this.gestionError(rejected));
  }

  searchSav() {
    console.log(this.search.value);
    if (this.search.valid) {
      this.searching = true;
      this.db.searchFAQ(this.search.value).valueChanges().forEach( recherche => {
        this.recherche = recherche;
      });
    } else {
      this.searching = false;
      this.faq = this.db.getAllSav();
    }

  }
}



// WEBPACK FOOTER //
// /Users/Mustafa/Developpement/noxoe/src/components/account/account.component.ts